import apiClient from "./api.client.service";
import { Widget } from "../Entities/Widget";

class WidgetService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async createOrUpdateWidget(position: string): Promise<Widget | null> {
    try {
      const res = await apiClient.post(`${this.APIBaseUrl}/widget`, {
        position: position,
      });
      return res.data || null;
    } catch (error: any) {
      console.error("Error creating widget:", error);
      return null;
    }
  }

  async getWidget(): Promise<Widget | null> {
    try {
      const res = await apiClient.get(`${this.APIBaseUrl}/widget`);
      return res.data || null;
    } catch (error: any) {
      console.error("Error getting widget:", error);
      return null;
    }
  }
}

const widgetService = new WidgetService();

export default widgetService;